import { Link } from 'react-router-dom'
import { Mail, Instagram, Twitter, Github } from 'lucide-react'

const COLLECTIONS_LINKS = [
  { label: 'Gaming', href: '/collections/gaming' },
  { label: 'Cyberpunk', href: '/collections/cyberpunk' },
  { label: 'Astral', href: '/collections/astral' },
  { label: 'Japonaise', href: '/collections/japonaise' },
  { label: 'Dark Academia', href: '/collections/dark-academia' },
  { label: 'View All', href: '/catalogue' },
]

const SHOP_LINKS = [
  { label: 'All Products', href: '/catalogue' },
  { label: 'Custom Mat Builder', href: '/customize' },
  { label: 'New Arrivals', href: '/catalogue?sortBy=newest' },
  { label: 'Best Sellers', href: '/catalogue?sortBy=popular' },
]

const ACCOUNT_LINKS = [
  { label: 'My Account', href: '/account' },
  { label: 'Saved Designs', href: '/account/saved-designs' },
  { label: 'Order History', href: '/account#orders' },
]

export default function Footer() {
  return (
    <footer className="bg-brand-surface border-t border-brand-border mt-24">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-display text-2xl font-bold">
                <span className="text-white">Matryx</span>
                <span className="text-brand-purple">Lab</span>
              </span>
            </Link>
            <p className="text-brand-gray text-sm leading-relaxed mb-6">
              Premium custom and preset mouse mats. Design your own or choose from 19 curated collections. Drop-shipped worldwide.
            </p>
            <div className="flex items-center gap-3">
              <a href="https://instagram.com/matryxlab" target="_blank" rel="noopener noreferrer" className="btn-ghost p-2 rounded-lg" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="https://twitter.com/matryxlab" target="_blank" rel="noopener noreferrer" className="btn-ghost p-2 rounded-lg" aria-label="Twitter">
                <Twitter size={18} />
              </a>
              <a href="mailto:hello@matryxlabs.com" className="btn-ghost p-2 rounded-lg" aria-label="Email">
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Shop</h3>
            <ul className="space-y-2.5">
              {SHOP_LINKS.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-brand-gray text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Collections */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Collections</h3>
            <ul className="space-y-2.5">
              {COLLECTIONS_LINKS.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-brand-gray text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Account */}
          <div>
            <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Account</h3>
            <ul className="space-y-2.5">
              {ACCOUNT_LINKS.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-brand-gray text-sm hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <h3 className="font-semibold text-white mb-4 text-sm uppercase tracking-wider">Support</h3>
              <ul className="space-y-2.5">
                <li><a href="mailto:hello@matryxlabs.com" className="text-brand-gray text-sm hover:text-white transition-colors">Contact Us</a></li>
                <li><Link to="/faq" className="text-brand-gray text-sm hover:text-white transition-colors">FAQ</Link></li>
                <li><Link to="/shipping" className="text-brand-gray text-sm hover:text-white transition-colors">Shipping Info</Link></li>
                <li><Link to="/returns" className="text-brand-gray text-sm hover:text-white transition-colors">Returns Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="divider mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-brand-gray text-sm">
            © {new Date().getFullYear()} MatryxLab. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-brand-gray text-sm hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-brand-gray text-sm hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
